import PropTypes from 'prop-types';
import classes from './page.module.css';
import Title from './Title';
import Menu from './Menu';
import Extra from './Extra';
import Head from './Head';
import Actions from './Actions';
import Box from '../Box';

const Page = (props) => {
  const {
    title,
    subtitle,
    hideNews = false,
    hideHelp = false,
    children,
    menu = [],
    menuSize = 'md',
    extra,
    extraSize = 'md',
  } = props;

  return (
    <div className={classes.page}>
      {title && <Title title={title} subtitle={subtitle} hideNews={hideNews} hideHelp={hideHelp} />}
      <div className={classes.container}>
        <Menu data={menu} size={menuSize} />
        <div className={classes.content}>{children}</div>
        <Extra size={extraSize}>{extra}</Extra>
      </div>
    </div>
  );
};

Page.Head = Head;
Page.Section = Box;
Page.Actions = Actions;

Page.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  hideNews: PropTypes.bool,
  hideHelp: PropTypes.bool,
  children: PropTypes.any,
  menu: PropTypes.array,
  menuSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  extra: PropTypes.node,
  extraSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};

export default Page;
